'use client'

import { AUTH_LOGOUT_COOLDOWN_MS, AUTH_LOGOUT_COOLDOWN_UNTIL_KEY } from './logout-state'

function clearAuthAndNavigate(locale: string, targetPath: string) {
  window.sessionStorage.setItem(
    AUTH_LOGOUT_COOLDOWN_UNTIL_KEY,
    String(Date.now() + AUTH_LOGOUT_COOLDOWN_MS),
  )

  const params = new URLSearchParams({ redirect: targetPath })
  window.location.replace(`/api/auth/clear-session?${params.toString()}`)
}

export function clearAuthAndReturnHome(locale: string) {
  return clearAuthAndNavigate(locale, `/${locale}`)
}

export function clearAuthAndOpenSignIn(locale: string) {
  // SSO 登录进行中，跳过跳转，等待 SSO 完成
  if (typeof window !== 'undefined' && window.__ssoLoginPending) return
  const signInPath = `/${locale}?auth=signin`
  return clearAuthAndNavigate(locale, signInPath)
}
